import React from 'react';
import ServicePage from '../components/services/ServicePage';
import pavementSigns from '../data/services/pavement-signs';

const PavementSigns: React.FC = () => <ServicePage data={pavementSigns} />;

export default PavementSigns;
